import { Link } from "react-router-dom";
import { Phone, Home, CheckCircle2 } from "lucide-react";
import { SITE } from "@/config/site";
import { Seo } from "@/components/Seo";
import { trackEvent } from "@/lib/analytics";

export default function Merci() {
  return (
    <>
      <Seo title="Demande envoyée — Merci | FRELONS50" description="Votre demande d'intervention a bien été envoyée à FRELONS50." path="/merci" noindex />
      <section className="max-w-2xl mx-auto px-4 md:px-8 py-20 md:py-28 text-center">
        <div className="w-20 h-20 rounded-full bg-brand-gold/20 flex items-center justify-center mx-auto mb-6" data-testid="merci-icon">
          <CheckCircle2 className="w-11 h-11 text-brand-gold" />
        </div>
        <h1 className="font-display text-3xl md:text-5xl font-extrabold tracking-tight text-brand-black leading-[1.1]">
          Votre demande a bien été envoyée
        </h1>
        <p className="mt-5 text-lg text-brand-text leading-relaxed">
          Merci de votre confiance. Nous vous recontacterons dans les meilleurs délais. En cas d'urgence, vous pouvez nous
          appeler directement.
        </p>
        <div className="mt-9 flex flex-col sm:flex-row gap-3 justify-center">
          <a
            href={SITE.phoneHref}
            onClick={() => trackEvent("click_phone", { location: "merci" })}
            data-testid="merci-call-btn"
            className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-full bg-brand-gold text-brand-black font-bold hover:-translate-y-0.5 transition-transform"
          >
            <Phone className="w-5 h-5" /> Appeler le {SITE.phoneDisplay}
          </a>
          <Link
            to="/"
            data-testid="merci-home-btn"
            className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-full border-2 border-brand-black text-brand-black font-bold hover:bg-brand-black hover:text-white transition-colors"
          >
            <Home className="w-5 h-5" /> Retour à l'accueil
          </Link>
        </div>
      </section>
    </>
  );
}
